'use strict';

var GridExampleDirective = function GridExampleDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-example.html'),
    controller: 'GridExampleController'
  };
};
GridExampleDirective.$inject = [];
module.exports = GridExampleDirective;